import { slugify } from "@certn/utils";
import { JsonFormsCore } from "@jsonforms/core";
import { useJsonForms } from "@jsonforms/react";
import { useContext, useMemo, useState } from "react";

import { CascadiaJsonFormContext } from "../CascadiaJsonFormContext";
import { Switch } from "../components/Switch";
import {
  CascadiaControlProps,
  withCascadiaControlProps,
} from "../wrappers/withCascadiaControlProps";

function CurrentDateControl(props: CascadiaControlProps) {
  const context = useJsonForms();
  const { isSummary, parentValues } = useContext(CascadiaJsonFormContext);
  const [defaultSelected] = useState<boolean>(
    Object.keys(context?.core?.data ?? {}).length > 0 && !props.data
  );

  const allowCurrent = useMemo(() => {
    const hasCurrent = (parentValues as JsonFormsCore["data"][])?.find(
      (item) => item[props.path]
    );

    if (!hasCurrent) {
      return true;
    }
  }, [parentValues]);

  return (
    <>
      {(allowCurrent || !defaultSelected) && !isSummary && (
        <Switch
          id={props.id}
          defaultSelected={defaultSelected}
          isSelected={props.data}
          onChange={(selectedKey) => {
            if (!selectedKey) {
              props.handleChange("end_date", null);
            }
            props.handleChange(props.path, selectedKey);
          }}
          card={props.uischema.options?.card}
          // test id for switch input
          testID={`${slugify(props.path)}-switch-input`}
          // test-id for switch element (on label)
          data-testid={`${slugify(props.path)}-switch`}
        >
          {props.label}
        </Switch>
      )}
    </>
  );
}

export const CurrentDateControlRenderer =
  withCascadiaControlProps(CurrentDateControl);
